module.exports = __webpack_public_path__ + "static/motherChild-f0f05dac31e9faf194048b10a8804333.jpg";